export const REPLY_POST_COMMENT_MESSAGE = "ขออนุญาตทักแชท เพื่อให้ข้อมูลเพิ่มเติมนะคะ";
export const MESSENGER_PREVIEW_IMAGE_MOBILE = "/assets/img/messenger_preview_mobile.png";
export const MESSENGER_PREVIEW_IMAGE_DESKTOP = "/assets/img/messenger_preview_desktop.png";
export const FACEBOOK_DEFAULT_LINK = "https://www.facebook.com/permalink.php";
